module.exports = __webpack_public_path__ + "img/19b75094b88310b6aeaccd0fecadb5e.a6c0608a.jpg";